import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
// fallow-ignore-next-line circular-dependency -- co-located route modules import their parent layout route from routes.tsx, which imports this module back into the tree (same cycle as every migrated route).
import { workflowLayoutRoute } from 'src/routes';

// The workflow Activity tab (audit trail): a child of the (still centrally
// declared) `/workflows/$workflowId` layout, so its real URL is
// `/workflows/$workflowId/activity`.
//
// TRANSITIONAL LOCATION — see the sibling `memories/index.tsx` for why this
// module lives here rather than under `workflows/$workflowId/activity/`.
export const Route = createRoute({
  getParentRoute: () => workflowLayoutRoute,
  path: '/activity',
  component: lazyRouteComponent(
    () => import('../../workflows/WorkflowActivityTab'),
    'WorkflowActivityTab',
  ),
  loader: () => ({ crumb: msg('Activity', { context: 'page breadcrumb' }) }),
});
